'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:ModalChangeBillingPeriodCtrl
 * @description
 * # ModalChangeBillingPeriodCtrl
 * Picks a new billing period for an existing license. Resolves with the server's ChangedLicense so the caller can
 * update its copy of the license without reloading.
 *
 * The admin order detail opens it too, passing a license with `admin: true` and no key; that goes through the admin
 * endpoint instead.
 */
angular.module('360StoreAngularApp')
	.controller('ModalChangeBillingPeriodCtrl', function ($scope, $uibModalInstance, api, BILLING_PERIODS, /**ManagedLicenseSummary*/license) {
		$scope.license = license;
		$scope.current = license.billingPeriod || 'Annual';
		// a license already on a retired plan still shows it, so the customer can see what they are switching away from
		$scope.billingPeriods = BILLING_PERIODS.filter(o => o.offered || o.id === $scope.current);
		$scope.selected = $scope.current;
		$scope.saving = false;
		/** @type {string|undefined} why the server refused the last save */
		$scope.error = undefined;

		$scope.save = function () {
			if ($scope.selected === $scope.current) {
				return;
			}
			$scope.saving = true;
			$scope.error = undefined;
			const request = license.admin
				? api.adminChangeBillingPeriod([license.rootCartItemId], $scope.selected)
				: api.changeBillingPeriod(license.licenseKey, license.registeredTo, [license.rootCartItemId], $scope.selected);
			// .then rather than await: $http promises resolve inside a digest, so the modal closes without a manual $apply
			request
				.then(function (changed) {
					// The save has already happened by the time we get here. An older server build answers with a
					// different shape, so fall back to what we asked for rather than failing after a successful write.
					const updated = Array.isArray(changed)
						? changed.find(c => c.rootCartItemId === license.rootCartItemId)
						: null;
					$scope.saving = false;
					$uibModalInstance.close(updated || {rootCartItemId: license.rootCartItemId, billingPeriod: $scope.selected});
				})
				.catch(function (err) {
					$scope.saving = false; // leave the modal open to retry
					$scope.error = err?.headers?.()?.proscerror || 'The billing period could not be changed.';
				});
		};
	});
